import React from 'react';
import Section from '../../shared/reusables/Section';

const SKILLS = ['C#', 'JavaScript (ES6+)', 'React & Redux', 'HTML & CSS (Sass)', 'Responsive Web Design'];

const SkillsSection = ({ language }) => {
    const title = language === 'en' ? 'Skills' : 'Vaardigheden';

    return (
        <Section title={title}>
            <div className="skills-grid">
                {SKILLS.map((skill) => (
                    <span key={skill} className="skill-chip">{skill}</span>
                ))}
            </div>
        </Section>
    );
};

export default SkillsSection;
